<template>
  <div :style='mainContainerStyles' :class="{'is-ordering': isOrdering}">

    <div style='position: sticky'>
      <div v-if="isInFormView" style='box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05); height: 64px; padding: 8px 20px; background-color: #fff; display: flex; flex-direction: row; align-items: center; justify-content: center'>
        <div class='home-button-nav' @click='isInFormView = false'>
          <svg width='24px' height='24px' stroke-width='1.5' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' color='#000000'>
            <path d='M15 6l-6 6 6 6' stroke='#000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
          </svg>
        </div>
        <div class='text-m-bold'>{{ formUserData.id ? 'Editar contacto' : 'Nuevo contacto' }}</div>
      </div>

      <div v-else style='box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05); padding: 8px 20px; background-color: #fff; display: flex; flex-direction: column; align-items: center; justify-content: center'>
        <div style='height: 64px; display: flex; flex-direction: row; align-items: center; justify-content: center'>
          <div v-if='isOrdering && screenWidth > 767' class='home-button-nav-right' @click='handleBackButton'>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="m6 6 12 12m0-12L6 18" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div v-else class='home-button-nav' @click='handleBackButton'>
            <svg width='24px' height='24px' stroke-width='1.5' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' color='#000000'>
              <path d='M15 6l-6 6 6 6' stroke='#000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
            </svg>
          </div>
          <div class='text-m-bold'>Contactos</div>
        </div>
        <div style='display: flex; align-items: center; justify-content: center; width: 100%; gap: 8px;'>
          <InputText
            isOptional
            :maxLength='150'
            placeholder='Busca un contacto'
            v-model='textToFilter'
          />
          <div>
            <ButtonDefinitive
              variant='secondary'
              isIconOnly
              @click='openAddContact'
            >
              <template v-slot:icon>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12h12m-6-6v12" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </template>
            </ButtonDefinitive>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isInFormView" :style="bodyStyles">

      <article v-if="contacts.length === 0" class='empty-registers-container'>
        <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M47.997 89.993c28.003 0 41.996-18.802 41.996-41.996S76 6 47.997 6C19.993 6 6 24.803 6 47.997s13.993 41.996 41.997 41.996" fill="#FFC740"/><path d="M39 72a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9" fill="#993438"/><path d="M31.5 57C38.956 57 45 50.956 45 43.5S38.956 30 31.5 30 18 36.044 18 43.5 24.044 57 31.5 57m33 0C71.956 57 78 50.956 78 43.5S71.956 30 64.5 30 51 36.044 51 43.5 57.044 57 64.5 57" fill="#fff"/><path d="M24.208 23.963c-1.778 1.688-2.854 3.72-3.285 5.011a1.5 1.5 0 1 1-2.846-.948c.57-1.71 1.894-4.177 4.066-6.239C24.339 19.702 27.444 18 31.5 18a1.5 1.5 0 0 1 0 3c-3.143 0-5.539 1.298-7.292 2.963M36 51a6 6 0 1 0 0-12 6 6 0 0 0 0 12m24 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12m15.077-22.026c-.43-1.29-1.506-3.323-3.285-5.011C70.04 22.298 67.644 21 64.5 21a1.5 1.5 0 1 1 0-3c4.056 0 7.161 1.702 9.358 3.787 2.171 2.062 3.495 4.53 4.065 6.239a1.5 1.5 0 1 1-2.846.948" fill="#121212"/></svg>
        <div style='text-align: center;'>
          <p class='text-m-regular'>Aún no has</p>
          <p class='text-m-regular'>guardado contactos</p>
        </div>
        <ButtonDefinitive
          variant='secondary'
          label='+ Nuevo contacto'
          @click='openAddContact'
        />
      </article>

      <div v-else-if='contactsFiltered.length > 0' :class="{'isButtonShowed': true}">
        <div v-for='(contact, i) in contactsFiltered' v-bind:key='contact.contactId'>
          <Contact
            :contact='contact'
            :elKey='i'
            :contactList='contactsFiltered'
            @editAction='openDetailContact'
            @deleteAction='deleteContactConfirmation'

            :reference='reference'
            :isOrdering='isOrdering'
            :contactSelectedId='contactSelectedId'
            @handleSelectContact='selectContact'
          />
        </div>
        <div
          v-show='contactSelectedId'
          style='position: absolute; margin: auto; bottom: 32px; left: 0; right: 0; width: 85%; transition: .3s'
        >
          <ButtonDefinitive
            :label="modalContactType === 'origin' ? 'Confirmar remitente' : 'Confirmar destinatario'"
            @click='confirmContactSelected'
          />
        </div>
      </div>
      <div v-else class='empty-registers-container'>
        <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M47.997 89.993c28.003 0 41.996-18.802 41.996-41.996S76 6 47.997 6C19.993 6 6 24.803 6 47.997s13.993 41.996 41.997 41.996" fill="#FFC740"/><path d="M45 43.5C45 50.956 38.956 57 31.5 57S18 50.956 18 43.5 24.044 30 31.5 30 45 36.044 45 43.5m33 0C78 50.956 71.956 57 64.5 57S51 50.956 51 43.5 57.044 30 64.5 30 78 36.044 78 43.5" fill="#fff"/><path d="M33 54a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9m30 0a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9" fill="#121212"/><path d="M96 0H0v96h96zM66.444 16.314l3.713 2.167-.501 5.362a21.07 21.07 0 0 0 9.957 7.821l2.912-1.313 1.531 2.444A26 26 0 0 0 84 34.5c0 4.136.985 8.042 2.733 11.497l-.686 3.45-2.99 1.07A16.4 16.4 0 0 0 81 58.5q0 1.183.162 2.322a21.05 21.05 0 0 0-13.813 12.755 25.4 25.4 0 0 0-8.113-1.567C57.386 66.762 52.382 63 46.5 63c-4.268 0-8.073 1.98-10.547 5.072C31.557 63.12 25.143 60 18 60h-.067a16.5 16.5 0 0 0-6.808-11.903l-2.933.293-.723-2.277C12.072 42.26 15 36.473 15 30q0-.225-.005-.451l2.742-1.437s2.59 1.877 3 1.855c6.873-.373 12.926-3.83 16.798-9.011l1.196-6.785 3.23-5.336C45.408 14.34 51.527 18 58.5 18c2.829 0 5.517-.602 7.944-1.686" fill="#FBFBFF"/><path d="M0 56.13v-6a21 21 0 0 0 7.469-4.017 16.5 16.5 0 0 1 3.684 2.004A21.04 21.04 0 0 1 0 56.13m0 30.803v-9q.741.066 1.5.067c5.576 0 10.506-2.765 13.492-7C14.742 79.38 8.246 86.19 0 86.933M33.042 96h-7.923a25.5 25.5 0 0 1 5.454-9.59 13.5 13.5 0 0 1-.575-3.91c0-3.382 1.244-6.475 3.3-8.843-.196.916-.3 1.868-.3 2.843 0 3.308 1.19 6.338 3.165 8.686A25.35 25.35 0 0 0 33.042 96m58.835 0h-7.923a25.4 25.4 0 0 0-7.143-16.245A25.57 25.57 0 0 1 91.877 96M96 74.933v5.446a16.53 16.53 0 0 1-11.455-11.66A16.48 16.48 0 0 0 96 74.933m.002-18.795v7.607a25.6 25.6 0 0 1-12.951-13.213 16.6 16.6 0 0 1 3.684-4.534 25.6 25.6 0 0 0 9.267 10.14M39.407 2.484A19.4 19.4 0 0 0 36 13.5c0 2.66.532 5.196 1.497 7.506a22.4 22.4 0 0 0 4.464-12.17 19.4 19.4 0 0 1-2.554-6.352m35.537 6.504a19.6 19.6 0 0 1-8.499 7.326 20.9 20.9 0 0 0 3.24 7.569A19.43 19.43 0 0 0 75.001 10.5q0-.763-.058-1.512m13.776 10.73a25.57 25.57 0 0 0-9.143 11.932c1.426.54 2.925.927 4.48 1.145.32-4.856 2-9.34 4.663-13.077m-73.721 9.831a22.6 22.6 0 0 0 5.787.415c-1.168-8.063-6.916-14.642-14.521-17.015 5.179 3.731 8.59 9.764 8.734 16.6" fill="#CDB6FB"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h96v96H0z"/></clipPath></defs></svg>
        <div style='text-align: center;'>
          <p class='text-m-regular'>No encontramos</p>
          <p class='text-m-regular'>ese contacto</p>
        </div>
      </div>

    </div>

    <div v-else class='form_view' style='background-color: #FBFBFF; flex: 1; overflow-y: auto'>
      <div v-if='!isOrdering || modalContactType === "origin"' style='margin: -12px 0 4px -12px'>
        <CustomRadioButton
          radioId='1'
          :inputValue='1'
          v-model='formUserData.userType'
          label='Persona'
        />
        <CustomRadioButton
          radioId='2'
          :inputValue='2'
          v-model='formUserData.userType'
          label='Negocio'
        />
      </div>
      <InputText
        :label="formUserData.userType === 1 ? 'Nombre(s) y apellidos' : 'Nombre del negocio'"
        :maxLength='150'
        placeholder=''
        v-model='formUserData.name'
        :missingErrorMessage="formUserData.userType === 1 ? 'Ingresa los nombre(s) y apellidos.' : 'Ingresa el nombre del negocio.'"
        :showEmptyInputError='tryToSaveUserData && !formUserData.name'
      />
      <div>
        <InputText
          label='Número de celular'
          number
          :maxLength='12'
          placeholder=''
          v-model='formUserData.number'
          missingErrorMessage='Ingresa el número de celular.'
          :showEmptyInputError='tryToSaveUserData && !formUserData.number'
        />
        <ErrorMessage v-show='lessThanNineDigitsFlag && formUserData.number.length !== 9' message='Número debe tener 9 dígitos' />
      </div>
      <div>
        <InputText
          label='Correo electrónico (opcional)'
          :maxLength='150'
          isOptional
          placeholder=''
          v-model='formUserData.email'
        />
        <ErrorMessage v-show='formUserData.email && invalidEmailFlag && !isAValidEmail' message='Ingresa un correo electrónico válido: ejemplo@correo.com' />
      </div>
      <div v-if="isOrdering && action === 'store'" style='padding-top: 16px;'>
        <CustomCheckbox
          checkboxId='save-contact'
          v-model="saveContact"
          label="Guardar en mi lista de contactos."
        />
      </div>
      <div v-if="!reference.includes('destination')" style='padding-top: 16px;'>
        <CustomCheckbox
          checkboxId='sender-predetermined'
          v-model="formUserData.isPredetermined"
          label="Establecer como remitente predeterminado."
        />
      </div>
      <div style='padding-top: 16px;'>
        <ButtonDefinitive
          :label='buttonLabel'
          @click='validateForm'
        />
      </div>
    </div>

  </div>
</template>

<script>
import ButtonDefinitive from '../components/Button/ButtonDefinitive.vue'
import CustomRadioButton from '../components/Form/CustomRadioButton.vue'
import InputText from '../components/Form/InputText.vue'
import CustomCheckbox from '../components/Form/CustomCheckbox.vue'
import ErrorMessage from '../components/ErrorMessage.vue'
import {
  deleteFavoriteContact,
} from '../services/client'
import Contact from '../components/Favorites/Contact.vue'

export default {
  name: 'ContactsView',
  // title: 'Contactos - Scharff',
  components: {
    ButtonDefinitive,
    CustomRadioButton,
    InputText,
    CustomCheckbox,
    ErrorMessage,
    Contact
  },
  props: {
    isOrdering: {
      type: Boolean,
      default: false
    },
    reference: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedContact: null,
      isInFormView: false,
      formUserData: {
        id: '',
        userType: 1,
        name: '',
        number: '',
        email: '',
        isPredetermined: false
      },
      tryToSaveUserData: false,
      action: '',
      textToFilter: '',
      lessThanNineDigitsFlag: false,
      invalidEmailFlag: false,

      contactSelectedId: 0,
      contactSelected : {},
      saveContact: false,

      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      screenHeight2: document.documentElement.clientHeight,
    }
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth
      this.screenHeight = window.innerHeight
      this.screenHeight2 = document.documentElement.clientHeight
    },
    selectContact(contactId) {
      this.contactSelectedId = contactId
      this.contactSelected = this.contacts.find(contact => contact.contactId === contactId)
    },
    confirmContactSelected() {
      this.$emit('contactSelectedData', this.contactSelected)
      this.isInFormView = false

      this.trackEvent('confirmar_contacto', 'contactos')
    },
    handleBackButton() {
      if (this.isOrdering) return this.$emit('handleGoBackButton')
      window.location.href = process.env.VUE_APP_WEBURL
    },
    async fetchContacts() {
      this.showLoading()
      this.tryToSaveUserData = false
      try {
        const resp = await this.$store.dispatch('GET_CONTACTS')
        if (resp.status === 200) {
          this.isInFormView = false
          this.resetFormUserData()
          this.$store.dispatch('GENERAL_SET_CONTACTS', resp.data.result.list)
        } else throw Error(resp.data.message)
      } catch (e) {
        console.log({ e })
        const msg = e?.data?.message || 'Ocurrió un error.'
        this.showError(msg)
      } finally {
        this.$swal.close()
      }
    },
    async deleteContactConfirmation(contact) {
      const response = await this.$swal({
        title: 'Confirme',
        html: '¿Desea eliminar este contacto de favoritos?',
        icon: 'question',
        confirmButtonText: 'Aceptar',
        showDenyButton: true,
        denyButtonText: 'Cancelar'
      })
      if (response.isConfirmed){
        this.deleteContact(contact.contactId)
        this.trackEvent('eliminar_contacto', 'contactos');
      } 
        

    },
    async deleteContact(contactId) {
      this.showLoading()
      await deleteFavoriteContact(contactId)
      this.$swal.close()
      this.fetchContacts()
    },
    validateForm() {
      const {
        id, name, number, email, userType, isPredetermined
      } = this.formUserData

      this.tryToSaveUserData = true
      if (!name) return
      if (!number || number.length > 12) return
      // if (number.length < 9) return this.lessThanNineDigitsFlag = true
      if (email && !this.isAValidEmail) return this.invalidEmailFlag = true
      const payload = {
        tipoContactoId: userType,
        nombreContacto: name,
        telefonoContacto: number,
        correoContacto: email,
        esPredeterminado: isPredetermined,
      }

      if (this.isOrdering) {
        payload.contactId = null
        this.contactSelected = payload
        this.confirmContactSelected()

        if (!this.saveContact && this.action === 'store') return this.resetFormUserData()
      }

      if(this.action === 'update') {
        payload.contactId = id
        this.saveChangesContact(payload)
      } else {
        this.getNewContact(payload)
      }
    },
    getNewContact(payload) {
      this.showLoading('Guardando Contacto...')
      this.$store
        .dispatch('POST_CONTACTS', payload)
        .then(success => {
          this.$swal.close()
          if (success.status !== 200) this.showError(success.data.message)
          this.fetchContacts()
        })
        .catch(error => {
          const msg = error?.data?.message || 'Ocurrió un error.'
          this.showError(msg)
        })
    },
    saveChangesContact(payload) {
      this.showLoading('Guardando Contacto...')
      this.$store
        .dispatch('PUT_CONTACTS', payload)
        .then(success => {
          this.$swal.close()
          if (success.status !== 201) {
            this.showError(success.data.message)
            this.fetchContacts()
          }
        })
        .catch(error => {
          const msg = error?.data?.message || 'Ocurrió un error.'
          this.showError(msg)
        })
    },
    openAddContact() {
      this.action = 'store'
      this.isInFormView = true
      this.resetFormUserData()
      this.trackEvent('agregar_contacto', 'contactos')
    },
    openDetailContact(contact) {
      this.action = 'update'
      this.isInFormView = true
      this.formUserData = {
        id: contact.contactId,
        userType: contact.tipoContactoId,
        name: contact.nombreContacto,
        number: contact.telefonoContacto,
        email: contact.correoContacto,
        isPredetermined: contact.esPredeterminado
      }

      this.trackEvent('editar_contacto', 'contactos')
    },
    resetFormUserData() {
      this.formUserData = {
        id: '',
        userType: 1,
        name: '',
        number: '',
        email: '',
        isPredetermined: false
      }
    }
  },
  mounted() {
    this.$nextTick(async () => {
      this.$store.dispatch('STYLE_MAP_SAIO', false)
      this.closeSidebar()
      this.$store.dispatch('STYLE_CUSTOM_DIV', process.env.VUE_APP_STYLE_HOME_FAVORITES)
      if (!this.isOrdering) {
        this.fetchContacts()
        document.title = 'Contactos - Sharf'
      }
    })

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    contacts() { return this.$store.getters.GENERAL_CONTACTS },
    contactsFiltered() {
      if (!this.textToFilter) return this.contacts
      return this.contacts.filter(contact => contact.nombreContacto.toLowerCase().includes(this.textToFilter.toLowerCase()))
    },
    isAValidEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(this.formUserData.email)
    },
    mainContainerStyles() {
      const styles = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden'
      }
      return styles
    },
    buttonLabel() {
      if (!this.isOrdering) return 'Guardar'

      // Esto es para saber si el contacto para origen o destino
      const contactType = this.modalContactType

      const endWord = contactType === 'origin' ? 'remitente' : 'destinatario'
      if (this.saveContact) {
        return `Confirmar y guardar ${endWord}`
      } else {
        return `Confirmar ${endWord}`
      }
    },
    modalContactType() {
      return this.$store.getters.MODAL_CONTACT_TYPE
    },
    bodyStyles() {
      const styles = {
        backgroundColor: '#FFF',
        overflowY: 'auto',
        height: '100%'
      }

      // Solo hay ese padding cuando sea celular, las barras del navegador estén visibles y no este generando pedido
      if (
        this.screenWidth < 767 &&
        (this.screenHeight === this.screenHeight2) &&
        !this.isOrdering
      ) {
        styles.paddingBottom = '200px'
      }
      return styles
    }
  },
  watch: {
    'formUserData.isPredetermined'(newValue) {
      if (newValue && this.isOrdering) {
        this.saveContact = true
      }
    },
    saveContact(newValue) {
      if (!newValue && this.isOrdering) {
        this.formUserData.isPredetermined = false
      }
    },
    '$store.getters.SCHARFFPOINT_ORIGIN_CONTACT': function(val) {
      if (this.reference.includes('origin')) {
        this.contactSelectedId = val?.contactId || 0
      }
    },
    '$store.getters.PROGRAMMED_ORIGIN_CONTACT': function(val) {
      if (this.reference.includes('origin')) {
        this.contactSelectedId = val?.contactId || 0
      }
    },
  },
}
</script>

<style scoped lang='scss'>
  .empty-registers-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }

  .form_view {
    padding: 32px 16px 32px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .isButtonShowed {
    padding-bottom: 112px;
  }

  .is-ordering{
    @media (min-width: 767px) {
      height: 80vh !important;
    }
  }
</style>